import React, { useState, useEffect } from "react";
import { Input, Button, Row, Col, Form, Card, Typography, message } from "antd";
import axiosInstance from "../../utils/axiosInstance";

const { Title } = Typography;

const GameRates = () => {
  // --- 1. Ant Design Message Hook (Toast Fix) ---
  const [messageApi, contextHolder] = message.useMessage();

  // --- State ---
  const [jodiDigit, setJodiDigit] = useState("");
  const [jodiDigitValue, setJodiDigitValue] = useState("");
  const [rateId, setRateId] = useState(""); 
  const [loading, setLoading] = useState(false);

  // --- 2. Fetch Bet Rates (GET API) ---
  const fetchBetRates = async () => {
    try {
      setLoading(true);
      const accessToken = localStorage.getItem("accessToken");
      
      const response = await axiosInstance.get("/api/jackpotRate/getBetRates", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      //console.log("📥 Fetched Data:", response.data); // Debugging

      if (response.data) {
        const { _id, jodiDigit, jodiDigitValue } = response.data;
        if (_id) setRateId(_id);
        setJodiDigit(jodiDigit || "");
        setJodiDigitValue(jodiDigitValue || "");
      }
    } catch (error) {
     // console.error("Error fetching rates:", error);
      // Agar aap chahein to fetch fail hone par bhi toast dikha sakte hain:
      // messageApi.error("Failed to load rates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBetRates();
  }, []);

  // --- 3. Handle Submit (Add or Update) ---
  const handleSubmit = async () => {
    // Validation
    if (!jodiDigit || !jodiDigitValue) {
      messageApi.warning("⚠️ Please fill both Jodi Rate and Value!");
      return;
    }

    try {
      setLoading(true);
      const accessToken = localStorage.getItem("accessToken");
      
      const payload = {
        jodiDigit,
        jodiDigitValue,
      };

      let response;

      // Decide: Update or Add
      if (rateId) {
        // PUT (Update)
        response = await axiosInstance.put(
          `/api/jackpotRate/jackpotupdateBetRates/${rateId}`,
          payload,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
      } else {
        // POST (Add)
        response = await axiosInstance.post(
          "/api/jackpotRate/jackpotaddrate",
          payload,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
      }

      // --- Success Message Handling ---
      if (response.data && response.data.message) {
        // Backend ka message dikhayein
        messageApi.success(response.data.message);
      } else {
        // Fallback message
        messageApi.success("Rates saved successfully! 🎉");
      }

      // Data refresh karein
      fetchBetRates();

    } catch (error) {
      console.error("Error saving rates:", error);
      
      // Error Message Handling
      const errorMsg = error.response?.data?.message || "Error saving rates ❌";
      messageApi.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        background: "#f0f2f5",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      {/* IMPORTANT: Ye contextHolder zaroori hai. 
         Iske bina Toast screen par render nahi hoga. 
      */}
      {contextHolder}

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "20px",
        }}
      >
        <Title level={2} style={{ textAlign: "center", marginBottom: "30px" }}>
          Games Rates
        </Title>
        <Card
          bordered={false}
          style={{
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#28A745",
              padding: "15px 20px",
            }}
          >
            <Title level={4} style={{ color: "#fff", margin: 0 }}>
              Jodi Game Rates
            </Title>
          </div>
          
          {/* Form Area */}
          <Card bordered={false} style={{ padding: "20px" }}>
            <Form layout="vertical">
              <Row gutter={[16, 16]}>
                
                {/* Jodi Digit Rate */}
                <Col xs={24} sm={12}>
                  <Form.Item label="Jodi Digit (Rate)">
                    <Input
                      value={jodiDigit}
                      onChange={(e) => setJodiDigit(e.target.value)}
                      placeholder="Enter Jodi Digit Rate (e.g., 10)"
                    />
                  </Form.Item>
                </Col>
                
                {/* Jodi Digit Value */}
                <Col xs={24} sm={12}>
                  <Form.Item label="Jodi Digit (Value)">
                    <Input
                      addonBefore="₹"
                      value={jodiDigitValue}
                      onChange={(e) => setJodiDigitValue(e.target.value)}
                      placeholder="Enter Jodi Digit Value (e.g., 950)"
                    />
                  </Form.Item>
                </Col>

              </Row>
            </Form>
          </Card>

          {/* Footer Button */}
          <div
            style={{
              backgroundColor: "#F7F7F7",
              padding: "15px 20px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button 
              type="primary" 
              onClick={handleSubmit} 
              loading={loading}
              size="large"
            >
              {rateId ? "Update Rates" : "Add Rates"}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default GameRates;